/**
 * The sides of a storage place from which packages may be picked up.
 * Modeled as bit flags so pickup can be limited to one or more sides.
 * Must stay in sync with the backend PlaceAccessDirection enum.
 */
export enum PlaceAccessDirection {
  None = 0,
  Front = 1,
  Right = 2,
  Back = 4,
  Left = 8,
  All = 15,
}

export const allPlaceAccessDirections: PlaceAccessDirection[] = [
  PlaceAccessDirection.Front,
  PlaceAccessDirection.Right,
  PlaceAccessDirection.Back,
  PlaceAccessDirection.Left,
];

export function hasAccessDirection(value: number, direction: PlaceAccessDirection): boolean {
  return (value & direction) === direction;
}

export function toggleAccessDirection(value: number, direction: PlaceAccessDirection): number {
  return hasAccessDirection(value, direction) ? value & ~direction : value | direction;
}

export function setAccessDirection(value: number, direction: PlaceAccessDirection, enabled: boolean): number {
  return enabled ? value | direction : value & ~direction;
}
